<ds-modal [id]="'choosePaymentAmountModal'" [maxWidth]="800" [closeOthers]="true">
  <div class="modal-container">
    <h1 data-cy="choosePaymentAmountModalHeaderText">Choose a payment amount</h1>
    <form autocomplete="off" [formGroup]="choosePaymentAmountForm">
      <ds-column-layout [numberOfColumns]="'two'">
        <div column-left>
          <amfam-choose-payment-amount
            [choosePaymentAmountOptions]="choosePaymentAmountOptions?.radioButtonOptions"
            [formGroup]="choosePaymentAmountForm"
            (textChangeEvent)="textBoxChangeEvent($event)"
            (radioChangeEvent)="radioGroupChangeEvent()"
          >
          </amfam-choose-payment-amount>
          @if (hasValidationError) {
            <ds-form-control-message [control]="otherPaymentAmount"></ds-form-control-message>
          }
        </div>
        <div column-right>
          <amfam-account-description-minimal
            [option]="choosePaymentAmountOptions?.accountDescriptionDetails"
          ></amfam-account-description-minimal>
          @if (headingText && !errorBoxText) {
            <ds-warning-box
              [headingText]="headingText"
              [messageText]="messageText"
              [linkText]="linkText"
              (linkEvent)="linkEvent($event)"
              [postLinkText]="postLinkText"
            ></ds-warning-box>
          }
          @if (headingText && errorBoxText) {
            <ds-errorbox
              [headingText]="headingText"
              [messageText]="messageText"
              [linkText]="linkText"
              (linkEvent)="linkEvent($event)"
              [postLinkText]="postLinkText"
            ></ds-errorbox>
          }
        </div>
      </ds-column-layout>
    </form>
  </div>
  <call-to-action
    [disabled]="choosePaymentAmountForm.invalid"
    [primaryButtonName]="'Save'"
    (primaryEvent)="savePaymentAmount()"
  ></call-to-action>
</ds-modal>
